import List from 'src/storage/list';

export class ClinicProfileLocationsModel extends List {
  id = 'ClinicProfileLocationsModel';
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = null;
  listLimit = 5;
  defaultState = () => ({
    current: 'recent',
    manager: null
  });
  apiConfig = {
    refresh: {
      url: 'clinic/manager/hospitals',
      validation: {
        skip: 'number',
        limit: 'number'
      },
      cancellable: true
    },
    list: {
      url: 'clinic/manager/hospitals',
      validation: {
        skip: 'number',
        limit: 'number'
      },
      cancellable: true
    }
  };

  listParams(loadMore) {
    if (!this.state.clinic?.id) return null;
    const req = {
      managerToClinic: this.state.clinic?.id,
      skip: 0,
      limit: this.listLimit
    };
    const query = this.listInput('search');

    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
}

const model = new ClinicProfileLocationsModel();
export default model;
